import { QueryEnginServices } from "lucy/query-builder";
import { IContextProvider } from "../../../../uxp"

export const useQEServices = (uxpContext: IContextProvider): QueryEnginServices | null => {
    const hasHook = typeof (window as any)?.QueryBuilderComponents?.useQueryEngineService === "function";

    if (hasHook) {
        return (window as any).QueryBuilderComponents.useQueryEngineService(uxpContext);
    }

    console.info("QueryBuilder is not available. `useQueryEngineService` skipped.");
    return null;

}
export const useRefreshDataSources = (uxpContext: IContextProvider) => {
    const qe = useQEServices(uxpContext)

    return qe?.refreshDatasources || (() => { });
}